import { HTTP } from "@/service/axios";

/**
 * Document Approval API service.
 * All calls expect the caller's token to be set on the shared HTTP instance
 * (project convention: set Authorization header before dispatching).
 *
 * Backend contract:
 *   GET    /documents            list (supports search, status, page, limit)
 *   GET    /documents/:id        detail
 *   POST   /documents            create
 *   PUT    /documents/:id        update
 *   DELETE /documents/:id        remove
 *
 * Response shape (project convention): { success, obj | data, total? }
 */
export default {
  fetchList(params = {}) {
    return HTTP.get("documents", { params }).then((res) => res.data);
  },
  fetchDetail(id) {
    return HTTP.get(`documents/${id}`).then((res) => res.data);
  },
  create(payload) {
    return HTTP.post("documents", payload).then((res) => res.data);
  },
  update(id, payload) {
    return HTTP.put(`documents/${id}`, payload).then((res) => res.data);
  },
  remove(id) {
    return HTTP.delete(`documents/${id}`).then((res) => res.data);
  },
};
